'use client';
import React, { useEffect } from 'react';
import Modal from '@/components/modal/Modal';
import { ModalImageProps } from '@/components/modal/types';
import { Headline } from '@/components/headline/Headline';
import { Link } from '@/components/link/Link';
import SerializeDescription from '@/components/serialize-description/SerializeDescription';
import { BaseImage } from '@/components/baseImage/BaseImage';

const ImageModal: React.FC<ModalImageProps> = ({
  isOpen,
  size = 'medium',
  ariaLabel = 'Subvariant Modal',
  mainHeadline,
  description,
  secondHeadline,
  link,
  onClose,
  image,
  ...props
}) => {
  // Auto-close after 15 seconds
  useEffect(() => {
    if (!isOpen) return;

    const timer = setTimeout(() => {
      onClose?.();
    }, 15000);

    // Cleanup timer if modal is closed earlier
    return () => clearTimeout(timer);
  }, [isOpen, onClose]);

  return (
    <div>
      <Modal
        isOpen={isOpen}
        onClose={onClose}
        animation={'fade'}
        size={size}
        ariaLabel={ariaLabel}
        {...props}
      >
        <Modal.Header>
          {image && (
            <BaseImage
              {...image}
              className={'h-full w-full rounded-t-2xl'}
              classNameImage="h-full w-full object-cover"
              alt={'modal-car-image'}
              sizes="(max-width: 1024px) 100vw, 1024px"
            />
          )}
        </Modal.Header>
        <Modal.Body>
          <div
            className={
              'image-modal-body relative rounded-b-2xl border-transparent bg-brand-700 p-4 md:p-10'
            }
          >
            <div
              className="absolute inset-0 z-0 rounded-b-2xl border-transparent opacity-50"
              style={{
                backgroundImage:
                  'radial-gradient(circle at bottom right, #6AA9D2 20%, #052133 40%, transparent 100%)',
              }}
            />
            <div className={'content-wrapper z-100 relative'}>
              <div
                className={'flex justify-start text-sm font-medium text-white'}
              >
                WETTBEWERB
              </div>
              <Headline className={'mb-4'} {...mainHeadline}>
                {mainHeadline.title}
              </Headline>
              {secondHeadline && (
                <Headline {...secondHeadline}>{secondHeadline.title}</Headline>
              )}
              {description && (
                <div className={'modal-description text-base text-white'}>
                  <SerializeDescription description={description as any} />
                </div>
              )}
            </div>
            <div
              onClick={(e) => {
                e.preventDefault();
                onClose?.();
              }}
            >
              {link?.title && (
                <Link
                  {...link}
                  variant={'primary'}
                  rightIcon={{ name: 'chevron-right' }}
                  className={
                    'relative mt-10 w-full justify-start border border-white bg-transparent md:w-fit'
                  }
                >
                  {link.title}
                </Link>
              )}
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default ImageModal;
